export const SpaceLabelsRepository = Symbol.for('SpaceLabelsRepository');
